import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/img/login_icon2.png';
const _hoisted_1 = {
  style: {
    "padding-left": "10%",
    "padding-right": "10%"
  }
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [_createElementVNode("img", {
    class: "img-title",
    src: _imports_0,
    alt: ""
  }, null, -1)]))]);
}